module.exports = __webpack_public_path__ + "img/Postmodernisme_Aha.d37fcdea.jpg";